import React from "react";
import styled, { keyframes } from "styled-components";

const contextLoading = keyframes`
  0%, 100%{transform: scale(0.5);opacity: 0.2;}
  50%{transform: scale(1.2);opacity: 1;}
`;
const spinnerLoading = keyframes`
  0%{transform: rotate(0deg)}
  100%{transform: rotate(360deg)}
`;
const ContextLoaderContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const ContextLoaderDot = styled.div`
  height: ${props => props.size};
  width: ${props => props.size};
  background-color: ${props => props.color};
  border-radius: 50%;
  margin-right: calc(${props => props.size} / 2);

  &:last-child {
    margin-right: 0;
  }

  &:nth-child(1) {
    animation: ${contextLoading} 1s ease-in-out infinite;
  }

  &:nth-child(2) {
    animation: ${contextLoading} 1s ease-in-out infinite;
    animation-delay: 0.33s;
  }
  &:nth-child(3) {
    animation: ${contextLoading} 1s ease-in-out infinite;
    animation-delay: 0.66s;
  }
`;

const Spinner = styled.div`
  width: ${props => props.size};
  height: ${props => props.size};
  font-size: ${props => props.size};
  border-radius: 50%;

  border: 0.25em solid;
  border-color: ${props => props.color};
  border-right-color: transparent;
  animation: ${spinnerLoading} 1s ease-in-out infinite;
`;
const Loader = props => {
  if (props.contextLoader) {
    return (
      <ContextLoaderContainer>
        <ContextLoaderDot size={props.size} color={props.color} />
        <ContextLoaderDot size={props.size} color={props.color} />
        <ContextLoaderDot size={props.size} color={props.color} />
      </ContextLoaderContainer>
    );
  } else if (props.contextSpinner) {
    return (
      <ContextLoaderContainer>
        <Spinner size={props.size} color={props.color} />
      </ContextLoaderContainer>
    );
  }
};
Loader.defaultProps = {
  size: "1rem",
  color: "#484848"
};
export default Loader;
